import React, { useCallback, useState, useRef } from "react";
import { useApp } from "../providers";
import { SrtDispatchContainer, SrtTopRow, SrtLabel, SrtTimeWrapper, SrtMessage, SrtReplayButton } from "./styles";
import * as T from "../types";
import { format } from "date-fns";
import { Api } from "../utils";
import TranscriptLine from "./TranscriptLine";
// @ts-ignore
import ReplayIcon from "@assets/srt-icons/replay.svg";

export const Transcription = ({ transcription }: T.TranscriptionProps) => {
  const { darkMode, config } = useApp();

  const [audioSrc, setAudioSrc] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [audioLoaded, setAudioLoaded] = useState(false);
  const audioRef = useRef();

  const playTranscript = useCallback(async () => {
    if (audioLoaded) {
      audioRef.current?.play();
      return;
    }
    const audioBlob = await Api.getAudio({
      id: transcription.message.data.channelId,
      audioId: transcription.message.data.id
    });
    const audioUrl = URL.createObjectURL(audioBlob);

    setAudioSrc(audioUrl);
    setAudioLoaded(true);
    setPlaying(true);
  }, [transcription]);

  const channelName = config.channels[transcription.message.data.channelId]?.name || "";

  return (
    <SrtDispatchContainer darkMode={darkMode}>
      <SrtTopRow>
        <SrtLabel darkMode={darkMode}>{channelName}</SrtLabel>
        <SrtTimeWrapper darkMode={darkMode}>
          <SrtReplayButton darkMode={darkMode}>
            <ReplayIcon onClick={playTranscript} />
            {playing && audioSrc && <audio src={audioSrc} ref={audioRef} autoPlay={true} />}
          </SrtReplayButton>
          {format(transcription.message.data.sourceDate, "HH:mm:ss")}
        </SrtTimeWrapper>
      </SrtTopRow>
      <SrtMessage darkMode={darkMode}>
        <TranscriptLine segments={transcription.message.data.transcriptionSegments} />
      </SrtMessage>
    </SrtDispatchContainer>
  );
};
